import { Button, Container, Form, Table, Modal } from 'react-bootstrap';
import { GoDiffAdded, GoTrashcan } from 'react-icons/go';

import styles from './MedicamentosEmergenciais.module.css';

const MedicamentosEmergenciais = props => {
  return (
    <Container className={styles.container_suprimentos}>
      <Table responsive striped bordered hover variant="dark">
        <thead>
          <tr>
            <th style={{ width: '25%' }}>Tipo de Medicamento</th>
            <th>Descrição do Medicamento</th>
            <th style={{ width: '10%' }}>Qtd</th>
            <th style={{ width: '20%' }}>Ação</th>
          </tr>
        </thead>

        <tbody>
          {props.medicamentos.map((item, index) => {
            return (
              <tr key={`${item.nome}-${index}`}>
                <td>
                  <Form.Group controlId="tipoMedicamento">
                    <Form.Select
                      required
                      name="tipoMedicamento"
                      onChange={e => props.handleTipoMedicamento(index, e.target.value)}
                      value={props.medicamentos[index].tipoMedicamento}
                    >
                      <option value=""></option>
                      {props.tipoMedicamentoSelect.map(item => (
                        <option key={item} value={item}>{item}</option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </td>
                <td>
                  <Form.Group controlId="descricao">
                    <Form.Select
                      required
                      name="descricao"
                      onChange={e => props.handleMedicamentos(index, 'descricao', e.target.value)}
                      value={props.medicamentos[index].descricao}
                      disabled={props.getListaMedicamentosByTipo(props.medicamentos[index]
                        .tipoMedicamento)
                        .length === 0}
                    >
                      <option value=""></option>
                      {props
                        .getListaMedicamentosByTipo(props.medicamentos[index]
                        .tipoMedicamento)
                        .map(item => (
                          <option key={`${item.codigoInterno}-${item.descricao}`} value={item.descricao}>
                            {item.descricao}
                          </option>
                        ))}
                    </Form.Select>
                  </Form.Group>
                </td>
                <td>
                  <Form.Group controlId="quantidade">
                    <Form.Control
                      autoComplete="new-off"
                      required
                      type="number"
                      step="1"
                      name="quantidade"
                      onChange={e => props.handleMedicamentos(index, 'quantidade', e.target.value)}
                      value={props.medicamentos[index].quantidade}
                    />
                  </Form.Group>
                </td>
                <td>
                  <div className={styles.container_buttons}>
                    <Button
                      variant="warning"
                      id="deleteTableRow"
                      onClick={e => props.handleRemoveMedicamentos(index)}
                      disabled={index === 0 && props.medicamentos.length === 1}
                    >
                      <div className={styles.icon_container}>
                        <GoTrashcan className={styles.icon_trash} />Excluir
                      </div>
                    </Button>

                    <Button
                      variant="flat" className={styles.btn}
                      id="addTableRow"
                      onClick={props.handleAddMedicamentos}
                    >
                      <div className={styles.icon_container}>
                        <GoDiffAdded className={styles.icon_trash} />Incluir
                      </div>
                    </Button>
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
      
      <Modal show={props.showModal} onHide={props.handleModalClose}>
        <Modal.Header closeButton>
          <Modal.Title>Erro</Modal.Title>
        </Modal.Header>
        <Modal.Body>{props.medicamentoError}</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={props.handleModalClose}>
            Fechar
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default MedicamentosEmergenciais;
